module.exports = __webpack_public_path__ + "static/media/Group 1354.5ddeb554.svg";